namespace Matrix.Data {
    export class PartyRolePartiesColumns {
        static columnsKey = 'Data.PartyRoleParties';
    }
}
